import { jsx as _jsx } from "react/jsx-runtime";
import GenericSettingsPage from './GenericSettingsPage';
export default function SectionWidthsPage() {
    const columns = [
        { key: 'value', label: 'WIDTH', type: 'number', required: true, step: 0.1, min: 0 },
        { key: 'unit', label: 'Unit', type: 'text', required: true, defaultValue: 'ft' },
        { key: 'display_name', label: 'Display Name', type: 'text', required: true },
        { key: 'sort_order', label: 'Sort Order', type: 'number', required: true, defaultValue: 0 },
    ];
    return (_jsx(GenericSettingsPage, { tableName: "section_widths", title: "Section Widths", columns: columns, apiPath: "section_widths" }));
}
